import React, { useState, useEffect, useRef } from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    Button,
    Row, Col,
    Spinner
} from 'reactstrap';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';

// Api
import contrato_api from '../../../api/contrato_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import downloadBase64File from '../../../helpers/downloadFile';

//Components
import AdicionarContrato from './AdicionarContrato';


export default function FichaContrato({ btnVoltar, id }) {
    //Estado de exibição do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Estado de controle dos dados do contrato
    const [contrato, set_contrato] = useState({});

    //Estado de controle de expansão do conteudo de cada fase do contrato
    const [expandir_fases, set_expandir_fases] = useState({});

    //Estado de edição do contrato
    const [editar, setEditar] = useState(false);

    //Função que carrega os dados do contrato
    const loadContrato = () => {
        if (id) {
            set_show_loading(true);
            contrato_api.getItem(id).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                set_contrato(response.data);
                const _expandir_fases = {};
                response.data.contratoFases.map((value, index) => {
                    _expandir_fases[index] = false;
                });
                set_expandir_fases(_expandir_fases);
            }).finally(f => set_show_loading(false));
        }
    }

    //Função para expandir a fase do contrato
    const handleExpandirFase = (index) => {
        const _expandir_fases = { ...expandir_fases };
        _expandir_fases[index] = !_expandir_fases[index];
        set_expandir_fases(_expandir_fases);
    }

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true,
        documentTitle: `${contrato.identificacao}`,
        onAfterPrint: () => {
            const _expandir_fases = { ...expandir_fases };
            contrato.contratoFases.map((value, index) => {
                _expandir_fases[index] = false;
            });
            set_expandir_fases(_expandir_fases);
        }
    });

    useEffect(() => {
        loadContrato();
    }, []);

    if (editar)
        return <AdicionarContrato btnVoltar={() => setEditar(false)} contratoFicha={contrato} />

    return (
        <div className='content'>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className='d-flex align-items-center justify-content-between'>

                <Button onClick={btnVoltar}>
                    <i className="fas fa-chevron-left"></i> Voltar
                </Button>
                <div>
                    {/* <Button onClick={() => {
                        const _expandir_fases = { ...expandir_fases };
                        contrato.contratoFases.map((value, index) => {
                            _expandir_fases[index] = true;
                        });
                        set_expandir_fases(_expandir_fases);
                        setTimeout(() => {
                            handlePrint();
                        }, 500);
                    }} color="danger" className="mr-2">
                        <i className="fas fa-file-pdf mr-2"></i> Imprimir
                    </Button> */}
                    <Button onClick={() => setEditar(true)} color={"warning"}>
                        <i className="fas fa-pen mr-2"></i> Editar
                    </Button>
                </div>
            </div>
            <div className='shadowFicha p-3' style={{ backgroundColor: "#fff" }}>
                <div ref={componentRef}>


                    <div className='mb-3'>
                        <h3 className="titleContrato m-0">{contrato.identificacao}</h3>
                        <span className='ml-2'><span style={{ fontWeight: "bold" }}>Número Processo:</span> {contrato.numeroProcesso}</span>
                    </div>
                    <div>
                        <div className='pb-2 shadowFicha mb-4'>
                            <h5 className='p-2  titleFicha'>Identificação do contrato</h5>
                            <Row className=" w-100 m-0">
                                <Col lg="6" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Órgão:</span> {contrato.orgao}</p>
                                </Col>
                                <Col lg="6" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Unidade:</span> {contrato.unidade}</p>
                                </Col>
                                <Col lg="6" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Número Dotação:</span> {contrato.numeroDotacao}</p>
                                </Col>
                                <Col lg="6" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Número Despesa:</span> {contrato.numeroDespesa}</p>
                                </Col>
                                <Col lg="4" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Emissão:</span> {moment(contrato.emissao).format("DD/MM/YYYY")}</p>
                                </Col>
                                <Col lg="4" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Inicio Vigência:</span> {moment(contrato.inicioVigencia).format("DD/MM/YYYY")}</p>
                                </Col>
                                <Col lg="4" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Fim Vigência:</span> {moment(contrato.fimVigencia).format("DD/MM/YYYY")}</p>
                                </Col>
                                <Col lg="12" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Fonte Recurso:</span> {contrato.fonteRecurso}</p>
                                </Col>
                                <Col lg="12" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Especificação da Despesa:</span> {contrato.especificacaoDespesa}</p>
                                </Col>
                                <Col lg="12" md="12" >
                                    <p><span style={{ fontWeight: "bold" }}>Objeto:</span> {contrato.objeto}</p>
                                </Col>
                            </Row>
                        </div>
                        <div className='pb-2 shadowFicha mb-4 '>
                            <h5 className='p-2  titleFicha'>Documentos anexados</h5>
                            <div className='px-3'>
                                {contrato && contrato.contratoDocumentos?.map(value => {
                                    return (
                                        <Button className={"ml-2"} color={"primary"} outline onClick={() => downloadBase64File(value.base64, value.identificacaoDocumento)}>
                                            <i className='fas fa-file-alt mr-2'></i>{value.identificacaoDocumento}
                                        </Button>
                                    )
                                })}
                            </div>
                        </div>
                        {/* <div className='pb-2 shadowFicha mb-4'>
                            <h5 className='p-2  titleFicha'>Fases do contrato</h5>
                            <Row className=" w-100 m-0">
                                <Col md="0" lg="1" className='d-flex align-items-start justify-content-end'>
                                    <div className='bg-secondary h-100 d-lg-block d-md-none' style={{ width: "3px" }}>

                                    </div>
                                </Col>
                                <Col md="12" lg="11" className='d-flex flex-column align-items-start justify-content-end'>
                                    {
                                        contrato && contrato.contratoFases?.map((fase, index) => {
                                            return (
                                                <div key={index} style={{ position: "relative" }} className='shadowFicha contentGroup mb-4 w-100'>
                                                    <div className='text-white pointHistory d-lg-flex d-md-none noPrint'>
                                                        <i className='fas fa-check'></i>
                                                    </div>
                                                    <p onClick={() => handleExpandirFase(index)} className={`p-2 titleFicha ${expandir_fases[index] ? "" : "closeTitle"} d-flex align-items-center justify-content-between m-0`} >
                                                        <span>{moment(fase.inicio).format("DD/MM/YYYY")} a {moment(fase.fim).format("DD/MM/YYYY")} - {fase.identificacao}</span>
                                                        <i className={expandir_fases[index] ? 'fas fa-angle-down' : 'fas fa-angle-up'}></i>
                                                    </p>
                                                    <div className={`cardContainer ${expandir_fases[index] ? "" : "close"}`}>
                                                        <Row className="m-0 py-3">
                                                            <Col md="12">
                                                                <span><span style={{ fontWeight: "bold" }}>Situação da execução: </span>{fase.situacaoExecucao}</span>
                                                            </Col>
                                                            <Col md="12">
                                                                <span><span style={{ fontWeight: "bold" }}>Descrição completa: </span>{fase.descricaoCompleta}</span>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </Col>
                            </Row>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}